<template>
    <div>
         <!--面包屑导航区域-->
        <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/goodslist' }">参数管理</el-breadcrumb-item>
            <el-breadcrumb-item>编辑参数</el-breadcrumb-item>
        </el-breadcrumb>
        <!--卡片视图区-->
        <el-card>
            <el-form :model="editForm" :rules="editFormRules" ref="editFormRef"  label-width="100px" style="width:90%;margin:10px auto">
                    
                    <!-- <el-form-item label="经典名琴" prop="param8">
                        <myeditor @editorContent="change8($event)" :str="editForm.param8"></myeditor>
                    </el-form-item>
                    <el-form-item label="在线课程" prop="param9">
                        <myeditor @editorContent="change9($event)" :str="editForm.param9"></myeditor>
                    </el-form-item> -->
                    <el-form-item label="起租" prop="param2">
                        <myeditor @editorContent="change2($event)" :str="editForm.param2"></myeditor>
                    </el-form-item>
                    <el-form-item label="发货" prop="param3">
                        <myeditor @editorContent="change3($event)" :str="editForm.param3"></myeditor>
                    </el-form-item>
                    <el-form-item label="积分" prop="param4">
                        <myeditor @editorContent="change4($event)" :str="editForm.param4"></myeditor>
                    </el-form-item>
                    <el-form-item label="租赁必读" prop="param5">
                        <myeditor @editorContent="change5($event)" :str="editForm.param5"></myeditor>
                    </el-form-item>
                    <el-form-item label="租赁规则" prop="param6">
                        <myeditor @editorContent="change6($event)" :str="editForm.param6"></myeditor>
                    </el-form-item>
                    <!-- <el-form-item label="关于VOM" prop="param7">
                        <myeditor @editorContent="change7($event)" :str="editForm.param7"></myeditor>
                    </el-form-item> -->
                    <el-form-item>
                        <el-button type="primary" @click="EditSave">确 定</el-button>
                        <el-button >取 消</el-button>
                    </el-form-item>
            </el-form>
        </el-card>
    </div>
</template>
<script>
export default {
    data(){
        return {
            imgURL:this.GLOBAL.imgURL,
            uploadurl: this.GLOBAL.imgURL+'upload/',
            limitNum: 1,
            fileList:[],
            classlist:[],
            brandlist:[],
            id:'',
            //编辑表单数据
            editForm:{
                param1:'',
                param2:'',
                param3:'',
                param4:'',
                param5:'',
                param6:'',
                param7:'',
                param8:'',
                param9:''
            },
            //编辑表单验证规则
            editFormRules:{
                param1:[
                    { required: true, message: '请输入参数', trigger: 'blur' }
                ]
            },
        }
    },
    mounted () {
        this.id = this.$route.params.id
        this.editParams()
    },
    methods:{
        async editParams(){
            const { data: res } = await this.$http.get('paramsinfo/' + this.id)
            this.editForm = res.data
            console.log(this.editForm);
        },
        change1(data) {
            this.editForm.param1 = data;
        },
        change2(data) {
            this.editForm.param2 = data;
        },
        change3(data) {
            this.editForm.param3 = data;
        },
        change4(data) {
            this.editForm.param4 = data;
        },
        change5(data) {
            this.editForm.param5 = data;
        },
        change6(data) {
            this.editForm.param6 = data;
        },
        change7(data) {
            this.editForm.param7 = data;
        },
        change8(data) {
            this.editForm.param8 = data;
        },
        change9(data) {
            this.editForm.param9 = data;
        },
        async EditSave(){
              this.$refs.editFormRef.validate( async valid=>{
                if (!valid) return
                const { data:res } = await this.$http.post('paramsedit/'+this.id,this.editForm)
                if(res.status===0)
                {
                    this.$message.success('修改参数成功！')
                    this.$router.push({path: '/params'})
                }
              })
       },
    }
}
</script>
<style scoped>
    .cardcss{
        margin: 5px auto ;
        width: 100%;
        
    }
    .el-breadcrumb{
        width: 100%;
    }
    
</style>